import React from "react";
import { useI18n } from "../../lib/i18n";
import { ArrowRight } from "@phosphor-icons/react";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/90dd8daa-cd26-4f72-b7b0-ddd9192df92a/images/9009ecc706cb5750de031f95385a67da84116392bb4cb6d48df13924ea941baa.png";

export default function Hero() {
  const { t } = useI18n();

  return (
    <section
      data-testid="hero-section"
      className="relative min-h-screen flex items-end overflow-hidden"
    >
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0A1428]/85 via-[#0A1428]/60 to-[#0A1428]/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0A1428]/70 via-transparent to-transparent" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-[1400px] mx-auto px-6 lg:px-12 pb-20 pt-32">
        <div className="max-w-3xl animate-fade-up">
          <p className="overline mb-6 text-[#C5A059]" data-testid="hero-overline">
            {t.hero.overline}
          </p>
          <h1
            data-testid="hero-title"
            className="font-serif text-white text-5xl sm:text-6xl lg:text-7xl xl:text-8xl leading-[1.05] tracking-tight font-medium"
          >
            {t.hero.title}{" "}
            <span className="italic text-[#C5A059]">{t.hero.titleAccent}</span>
          </h1>
          <p className="mt-8 text-white/80 text-lg max-w-xl leading-relaxed">
            {t.hero.subtitle}
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <a
              href="#services"
              data-testid="hero-cta-primary"
              className="btn-primary"
            >
              {t.hero.ctaPrimary} <ArrowRight size={16} weight="bold" />
            </a>
            <a
              href="/properties"
              data-testid="hero-cta-secondary"
              className="btn-ghost-light"
            >
              {t.hero.ctaSecondary}
            </a>
          </div>

          {/* Stats */}
          <div className="mt-16 grid grid-cols-3 gap-8 max-w-2xl border-t border-white/15 pt-8">
            <div data-testid="hero-stat-1">
              <div className="font-serif text-4xl text-[#C5A059] font-medium">20+</div>
              <p className="text-white/60 text-xs uppercase tracking-widest mt-2">
                {t.hero.stat1}
              </p>
            </div>
            <div data-testid="hero-stat-2">
              <div className="font-serif text-4xl text-[#C5A059] font-medium">25+</div>
              <p className="text-white/60 text-xs uppercase tracking-widest mt-2">
                {t.hero.stat2}
              </p>
            </div>
            <div data-testid="hero-stat-3">
              <div className="font-serif text-4xl text-[#C5A059] font-medium">7,4%</div>
              <p className="text-white/60 text-xs uppercase tracking-widest mt-2">
                {t.hero.stat3}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
